import React, { useState, useEffect } from 'react';
import { useDarkMode } from '../../contexts/DarkModeContext';
import './PromotionalBanner.css';

const PromotionalBanner = () => {
    const [currentSection, setCurrentSection] = useState(0);
    const [isVisible, setIsVisible] = useState(false);
    const { isDarkMode } = useDarkMode();

    const sections = [
        {
            title: "معامل علمني",
            description: "اكتشف عالم التجارب العلمية المذهلة",
            icon: "🧪",
            color: "var(--primary-color)",
            link: "/lab"
        },
        {
            title: "امرح مع علمني",
            description: "تعلم من خلال الألعاب التفاعلية الممتعة",
            icon: "🎮",
            color: "var(--secondary-color)",
            link: "/play"
        },
        {
            title: "استكشف مع علمني",
            description: "اكتشف أسرار الكون والفضاء",
            icon: "🚀",
            color: "var(--accent-color)",
            link: "/discover"
        }
    ];

    useEffect(() => {
        // Show banner after a short delay
        const timer = setTimeout(() => setIsVisible(true), 500);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        // Auto-rotate sections every 4 seconds
        const interval = setInterval(() => {
            setCurrentSection((prev) => (prev + 1) % sections.length);
        }, 4000);

        return () => clearInterval(interval);
    }, [sections.length]);

    const handleSectionClick = (link) => {
        window.location.href = link;
    };

    return (
        <div className={`promotional-banner ${isVisible ? 'visible' : ''} ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
            <div className="banner-container">
                <div className="banner-header">
                    <h2 className="banner-title">
                        <span className="title-glow">اكتشف عالم علمني</span>
                    </h2>
                    <p className="banner-subtitle">اختر مغامرتك العلمية القادمة</p>
                </div>

                <div className="sections-container">
                    {sections.map((section, index) => (
                        <div
                            key={index}
                            className={`section-card ${index === currentSection ? 'active' : ''}`}
                            style={{ '--card-color': section.color }}
                            onClick={() => handleSectionClick(section.link)}
                        >
                            <div className="section-icon">
                                <span className="icon-emoji">{section.icon}</span>
                                <div className="icon-glow"></div>
                            </div>
                            <div className="section-content">
                                <h3 className="section-title">{section.title}</h3>
                                <p className="section-description">{section.description}</p>
                            </div>
                            <div className="section-arrow">
                                <span className="arrow-icon">→</span>
                            </div>
                            <div className="card-particles">
                                {[...Array(6)].map((_, i) => (
                                    <div key={i} className="particle" style={{
                                        '--particle-delay': `${i * 0.2}s`,
                                        '--particle-size': `${Math.random() * 4 + 2}px`
                                    }}></div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="banner-indicators">
                    {sections.map((_, index) => (
                        <button
                            key={index}
                            className={`indicator ${index === currentSection ? 'active' : ''}`}
                            onClick={() => setCurrentSection(index)}
                        ></button>
                    ))}
                </div>

                <div className="floating-elements">
                    <div className="floating-star star-1">⭐</div>
                    <div className="floating-star star-2">🌟</div>
                    <div className="floating-star star-3">✨</div>
                    <div className="floating-star star-4">💫</div>
                </div>
            </div>
        </div>
    );
};

export default PromotionalBanner; 